import { Text, VStack } from "@gluestack-ui/themed";

import { Select } from "@repo/core/components/core/Select";
import { PersonListTile } from "@repo/core/screens/Proposals/components/PersonListTile";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";

import { SelectAttendantController } from "./controller";

export const SelectAttendant = () => {
  const {
    back,
    attendantInfo,
    handleOnSubmitForm,
    attendants,
    handleSelectAttendant,
    isFetched
  } = SelectAttendantController();

  return (
    <PageScaffold
      isLoading={!isFetched}
      loadingTitle="Aguarde"
      loadingDescription="Carregando informações para proposta"
      onBackPress={back}
      onPressRightIcon={back}
      rightWebLabel="Fechar"
      title={!isFetched ? "" : "Atendente"}
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryOnPress={handleOnSubmitForm}
          secondaryText="Cancelar"
          secondaryOnPress={back}
        />
      }
    >
      <VStack gap="$6" flex={1} w="$full">
        <Text fontSize="$md" fontWeight={400} color="$textLight800">
          Selecione o atendente:
        </Text>
        <VStack>
          <Select
            name="selectAttendant"
            label="Atendente"
            placeholder={attendantInfo?.label || "Selecione o atendente"}
            options={attendants}
            onChange={handleSelectAttendant}
          />
        </VStack>
        {attendantInfo ? (
          <VStack>
            <PersonListTile
              id={attendantInfo?.value}
              name={attendantInfo?.label}
              isActive
            />
          </VStack>
        ) : null}
      </VStack>
    </PageScaffold>
  );
};
